var React = require('react');

function App (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_0_4077","style":{"maskType":"luminance"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0H0V24H16V19H24V0Z","fill":"white"})),React.createElement("g",{"mask":"url(#mask0_0_4077)","key":1},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 7H10V5H14V7Z","fill":"black","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 3H18V21H6V3ZM8 5V19H16V5H8Z","fill":"black","key":1})])]);
}

App.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = App;

App.default = App;
